import React from 'react';
import { calculateDailyAV } from './dispoUtils';
import './DispoContent.css';

interface DispoInputsProps {
  bestellmenge: number;
  wochenAV: number;
  bestand: number;
  dispoBestand: number;
  onBestellmengeChange: (value: number) => void;
  onWochenAVChange: (value: number) => void;
  onBestandChange: (value: number) => void;
  onDispoBestandChange: (value: number) => void;
}

const DispoInputs: React.FC<DispoInputsProps> = ({
  bestellmenge,
  wochenAV,
  bestand,
  dispoBestand,
  onBestellmengeChange,
  onWochenAVChange,
  onBestandChange,
  onDispoBestandChange,
}) => {
  const dailyAV = calculateDailyAV(wochenAV);

  return (
    <div className="dispo-inputs">
      <h3>Planungsdaten eingeben</h3>
      <div className="inputs-grid">
        <div className="input-group">
          <label htmlFor="bestellmenge">Bestellmenge</label>
          <input
            type="number"
            id="bestellmenge"
            value={bestellmenge}
            onChange={(e) => onBestellmengeChange(Number(e.target.value) || 0)}
            min="0"
            step="1"
          />
          <span className="input-hint">Stück pro Bestellung</span>
        </div>

        <div className="input-group">
          <label htmlFor="wochenAV">Wochen-AV</label>
          <input
            type="number"
            id="wochenAV"
            value={wochenAV}
            onChange={(e) => onWochenAVChange(Number(e.target.value) || 0)}
            min="0"
            step="1"
          />
          <span className="input-hint">Abverkauf pro Woche</span>
        </div>

        <div className="input-group">
          <label htmlFor="bestand">Bestand</label>
          <input
            type="number"
            id="bestand"
            value={bestand}
            onChange={(e) => onBestandChange(Number(e.target.value) || 0)}
            min="0"
            step="1"
          />
          <span className="input-hint">Aktueller Lagerbestand</span>
        </div>

        <div className="input-group">
          <label htmlFor="dispoBestand">Dispo-Bestand</label>
          <input
            type="number"
            id="dispoBestand"
            value={dispoBestand}
            onChange={(e) => onDispoBestandChange(Number(e.target.value) || 0)}
            min="0"
            step="1"
          />
          <span className="input-hint">Bestand + offene Lieferungen</span>
        </div>
      </div>

      <div className="calculated-values">
        <div className="calc-item">
          <span className="calc-label">Tages-AV (berechnet):</span>
          <span className="calc-value">{dailyAV.toFixed(0)} Stück/Tag</span>
        </div>

      </div>
    </div>
  );
};

export default DispoInputs;
